import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearAddEditModalValue,
    setActionType,
    setHasInputChange,
    setHasInputNoChange,
    setIsConfirmationModalOpen,
    setModalOpen,
    setModalType,
    setReload,
    setSelectedItem,
    setSelectedItems,
    setTemplateType
} from 'store/ResponseTemplate/actions';
import { useTheme } from '@mui/material/styles';
import {
    Button,
    IconButton,
    Box,
    FormControl,
    InputLabel,
    Grid,
    Stack,
    Breadcrumbs,
    Typography,
    Link,
    Popover,
    List,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Input
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useMutation } from '@apollo/client';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import FormFields from 'Components/FormFields';
import { EDIT_QUESTION_REGISTRY, UPDATE_QUESTION_REGISTRY } from 'schemas/mutation';
import { useNavigate, useParams } from 'react-router-dom';
import EditConfirmationModal from './EditConifrmationModal';
import AllQuestionsIcon from 'Components/Icons/AllQuestionsIcon';
import QuestionRegistryIcon from 'Components/Icons/QuestionRegistryIcon';
import { MoreHoriz } from '@mui/icons-material';
import StarFilledIcon from 'Components/Icons/StarFilledIcon';
import StarIcon from 'Components/Icons/StarIcon';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import TrashIcon from 'Components/Icons/TrashIcon';
import PerfectScrollbar from 'react-perfect-scrollbar';
import RecoverArrowIcon from 'Components/Icons/RecoverArrowIcon';
import DraftIcon from 'Components/Icons/DraftIcon';
import { checkIsPremiumPlan } from 'helper/checkPlan.helper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';
import { hasNoPermissionToEdit } from 'helper/permission.helper';
import PermisssionValidationWrapper from 'Components/PermissionWrapper/PermissionValidationWrapper';

const EditTemplate = () => {
    const { id: registryId } = useParams();
    const currentUrl = window.location.href;
    const isExtensionPage = currentUrl.includes('question-registry-email');
    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate();
    const { templateType, selectedItem, hasInputValue, hasInputNoChange, isConfirmationModalOpen, reload } = useSelector(
        (params) => params.response
    );
    const { companyData } = useSelector((params) => params.customization);
    const { pagePermissions } = useSelector((state) => state.authentication);
    const isEditNotPermitted = hasNoPermissionToEdit(PermissionTypes.questionRegistries, pagePermissions);
    // const [hasInputValueChangedPreviously, setHasInputValueChangedPreviously] = useState(false);
    const [drafted, setIsDrafted] = useState(false);
    // const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    // const [hasInputNoChange, setHasInputNoChange] = useState(false);
    const [updateSingleQuestionRegistry, { data: editSingleQuestionRegistry }] = useMutation(EDIT_QUESTION_REGISTRY);
    const [title, setTitle] = useState(selectedItem?.question);
    const [anchorEl, setAnchorEl] = useState(null);
    const [updateRegistry] = useMutation(UPDATE_QUESTION_REGISTRY);
    const [editFormState, setEditFormState] = useState({
        question: selectedItem?.question,
        response: selectedItem?.response,
        isDrafted: selectedItem?.drafted
    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (editSingleQuestionRegistry) {
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: clearAddEditModalValue });
            navigate(isExtensionPage ? `/dashboard/question-registry-email/${registryId}` : '/dashboard/question-registry');
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'success',
                    message: drafted ? 'Saved as draft sucessfully.' : 'Question has been added to your question registry.'
                }
            });
        }
    }, [editSingleQuestionRegistry, dispatch]);

    const handleEditResponse = async (values, drafted) => {
        dispatch({ type: SET_LOADING, loading: true });

        setIsDrafted(drafted);
        try {
            await updateSingleQuestionRegistry({
                variables: {
                    editQuestionRegistryInput: {
                        questionRegistryId: selectedItem._id,
                        companyId: companyData._id,
                        question: values.question,
                        response: values.response,
                        drafted: drafted
                    }
                }
            });
            if (isExtensionPage) {
                navigate(`question-registry-email/${id}`);
            } else {
                dispatch({ type: setReload, reload: !reload });
            }
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: e.message || 'Something error occured in server'
                }
            });
            setIsDrafted(false);
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };

    // const handleRecoverResponse = async (values) => {
    //     dispatch({ type: SET_LOADING, loading: true });

    //     try {
    //         await updateSingleQuestionRegistry({
    //             variables: {
    //                 editQuestionRegistryInput: {
    //                     questionRegistryId: selectedItem._id,
    //                     companyId: companyData._id,
    //                     question: values.question,
    //                     response: values.response,
    //                     deleted: false,
    //                     drafted: selectedItem.drafted
    //                 }
    //             }
    //         });
    //     } catch (e) {
    //         dispatch({
    //             type: SET_TOAST_OBJECT,
    //             toastObject: {
    //                 status: true,
    //                 variant: 'error',
    //                 message: e.message || 'Something error occured in server'
    //             }
    //         });
    //     } finally {
    //         dispatch({ type: SET_LOADING, loading: false });
    //     }
    // };

    const handleRecoverResponse = async (status, id) => {
        let registryIdsInput = id;
        let variables = {
            editQuestionRegistryInput: {
                questionRegistryIds: registryIdsInput,
                companyId: companyData._id,
                status
            }
        };
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });

        try {
            await updateRegistry({
                variables: { ...variables }
            });
            dispatch({ type: setReload, reload: !reload });
            if (status === 'restored')
                dispatch({
                    type: SET_TOAST_OBJECT,
                    toastObject: {
                        status: true,
                        message: `Question recovered successfully.`,
                        variant: 'success'
                    }
                });
            dispatch({ type: setSelectedItems, userSelectedItems: [] });
            dispatch({ type: setModalOpen, modalOpen: false });
            // dispatch({ type: setAllChecked, isAllChecked: false });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    message: e.message || 'Something went wrong. Please try again later.',
                    variant: 'error'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };

    const handleCloseConfirmation = (type) => {
        // if (type === 'Y') {
        //     dispatch({ type: setModalOpen, modalOpen: false });
        //     dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
        //     dispatch({ type: clearAddEditModalValue });
        // } else {
        //     dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
        // }

        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
        dispatch({ type: clearAddEditModalValue });
    };

    const handleDraftButtonClick = (values) => {
        if (!values.question) {
            return;
        }
        handleEditResponse(values, true);
    };

    useEffect(() => {
        dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
    }, []);

    useEffect(() => {
        if (!title) {
            setTitle(selectedItem?.question);
        }
    }, [title]);

    /**Update Starred Individually */
    const updateStarred = async (e) => {
        e.stopPropagation();
        const status = selectedItem?.starred === true ? 'unstarred' : 'starred';
        let variables = {
            editQuestionRegistryInput: {
                questionRegistryIds: [selectedItem?._id],
                companyId: companyData?._id,
                status
            }
        };
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });

        try {
            await updateRegistry({
                variables: { ...variables }
            });
            const newStatus = status === 'starred' ? true : false;
            dispatch({ type: setSelectedItem, selectedItem: { ...selectedItem, starred: newStatus } });
            dispatch({ type: setReload, reload: !reload });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    message: e.message || 'Something went wrong. Please try again later.',
                    variant: 'error'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };

    const handleDelete = () => {
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'delete' });
        dispatch({ type: setActionType, typeOfAction: 'I' });
        handleClose();
    };

    const handleFormStateChange = () => {
        if (editFormState.isDrafted && (editFormState.question || !editFormState.response)) {
            handleEditResponse(editFormState, true);
            return;
        }

        if (!editFormState.isDrafted && editFormState.question && editFormState.response) {
            handleEditResponse(editFormState, false);
            return;
        }
    };

    const handleNavigation = () => {
        handleCloseConfirmation('Y');
    };

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'question-delete-popover' : undefined;

    return (
        <>
            <Stack sx={{ padding: '24px 24px 16px' }} direction="row" justifyContent="space-between">
                <Stack direction="row">
                    <Breadcrumbs className="question-registry-breadcrumbs" separator={<NavigateNextIcon />} aria-label="breadcrumb">
                        <Link
                            onClick={handleNavigation}
                            sx={{
                                cursor: 'pointer'
                            }}
                        >
                            {templateType === 'drafted' ? (
                                <>
                                    <DraftIcon /> Drafts
                                </>
                            ) : templateType === 'starred' ? (
                                <>
                                    <StarIcon /> Starred
                                </>
                            ) : templateType === 'deleted' ? (
                                <>
                                    <TrashIcon /> Deleted
                                </>
                            ) : (
                                <>
                                    <AllQuestionsIcon /> All questions
                                </>
                            )}
                        </Link>
                        <Typography
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color={`${templateType === 'drafted' || selectedItem.drafted ? '#676767' : '#00214d'}`}
                            fontWeight="600"
                            component="span"
                            fontSize="0.875rem"
                            lineHeight="1.1"
                            className={`${templateType === 'drafted' || selectedItem.drafted ? 'drafted' : ''}`}
                        >
                            <QuestionRegistryIcon />
                            {title}
                        </Typography>
                    </Breadcrumbs>
                </Stack>
                <Stack direction="row" className="actions">
                    {templateType !== 'deleted' && checkIsPremiumPlan(companyData?.subscription?.plan) && (
                        <IconButton
                            className={`${selectedItem?.starred ? 'active' : ''} star-icon`}
                            onClick={updateStarred}
                            disableRipple
                            disabled={isEditNotPermitted}
                        >
                            {selectedItem?.starred ? <StarFilledIcon /> : <StarIcon />}
                        </IconButton>
                    )}
                    {templateType !== 'deleted' && (
                        <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                            <IconButton className="three-dots" disableRipple onClick={handleClick}>
                                <MoreHoriz className="dot" />
                            </IconButton>
                        </PermisssionValidationWrapper>
                    )}
                    <IconButton
                        onClick={() => {
                            if (hasInputValue && !hasInputNoChange) {
                                dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: true });
                                return;
                            }
                            handleCloseConfirmation('Y');
                        }}
                        className="modal-close"
                        disableRipple
                    >
                        <CloseOutlinedIcon className="icon-yellow-fill" />
                    </IconButton>
                </Stack>
            </Stack>
            <Divider sx={{ backgroundColor: '#EDE7F6' }} />

            <Box className="modal-body">
                <Formik
                    initialValues={{
                        isDrafted: selectedItem.drafted,
                        question: selectedItem.question,
                        response: selectedItem.response
                    }}
                    validationSchema={Yup.object().shape({
                        question: Yup.string().required('Please provide a question.'),
                        response: Yup.string().when('isDrafted', {
                            is: false,
                            then: Yup.string().required('Please provide a response.')
                        })
                    })}
                >
                    {({ handleBlur, handleChange, values, setFieldValue }) => (
                        <Form>
                            <Stack>
                                <PerfectScrollbar
                                    style={{ height: 'calc(100vh - 220px)', maxHeight: 'calc(100vh - 220px)', padding: '0 6px 0 0' }}
                                    options={{ suppressScrollX: true, useBothWheelAxes: false }}
                                >
                                    <Stack className="field-box" gap={1} sx={{ minHeight: '255px', maxHeight: 'calc(100vh - 72px)' }}>
                                        <FormControl sx={{ ...theme.typography.customInput }}>
                                            {/* <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel> */}
                                            {/* <FormFields
                                            type="outlined-input"
                                            name="question"
                                            label="Question"
                                            value={values.question}
                                            id="outlined-adornment-title"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                let flag = false;
                                                if (selectedItem.question !== e.target.value) flag = true;
                                                dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                if (!e.target.value && !values.response)
                                                    dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                handleChange(e);
                                            }}
                                            inputprops={{}}
                                        /> */}

                                            <Input
                                                type="outlined-input"
                                                name="question"
                                                value={values.question}
                                                id="outlined-adornment-title"
                                                onBlur={handleBlur}
                                                placeholder="Untitled question"
                                                disabled={isEditNotPermitted}
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (selectedItem.question !== e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!e.target.value && !values.response)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                    setTitle(e.target.value !== '' ? e.target.value : selectedItem?.question);
                                                    setEditFormState({
                                                        ...editFormState,
                                                        question: e.target.value
                                                    });
                                                }}
                                                inputprops={{}}
                                            />
                                        </FormControl>

                                        <FormControl sx={{ ...theme.typography.customInput }} className="contact-textarea-formcontrol">
                                            {/* <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel> */}
                                            {/* <FormFields
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.response}
                                            name="response"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                let flag = false;
                                                if (selectedItem.response !== e.target.value) flag = true;
                                                dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                if (!values.question && !e.target?.value)
                                                    dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                handleChange(e);
                                            }}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        /> */}

                                            <Input
                                                id="outlined-adornment-responsetext-response"
                                                type="outlined-input"
                                                value={values.response}
                                                name="response"
                                                placeholder="Type your response here"
                                                onBlur={handleBlur}
                                                disabled={isEditNotPermitted}
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (selectedItem.response !== e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!values.question && !e.target?.value)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                    setEditFormState({
                                                        ...editFormState,
                                                        response: e.target.value
                                                    });
                                                }}
                                                label="Response"
                                                multiline
                                                // rows={4}
                                            />
                                        </FormControl>
                                    </Stack>
                                </PerfectScrollbar>
                                <Stack
                                    justifyContent="flex-end"
                                    direction="row"
                                    sx={{
                                        padding: '16px'
                                    }}
                                    gap={1}
                                >
                                    {templateType !== 'deleted' && (
                                        <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                                            <Button
                                                type="submit"
                                                className="alternate-reversed"
                                                disabled={hasInputNoChange || !values?.question}
                                                onClick={() => {
                                                    setFieldValue('isDrafted', true);
                                                    handleDraftButtonClick(values);
                                                }}
                                            >
                                                Save as draft
                                            </Button>
                                        </PermisssionValidationWrapper>
                                    )}

                                    {templateType === 'deleted' ? (
                                        <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                                            <Button
                                                type="submit"
                                                className="alternate white btn-recover"
                                                startIcon={<RecoverArrowIcon />}
                                                disableRipple
                                                size="large"
                                                onClick={() => {
                                                    // handleRecoverResponse(values);

                                                    handleRecoverResponse('restored', selectedItem._id);
                                                }}
                                            >
                                                Recover
                                            </Button>
                                        </PermisssionValidationWrapper>
                                    ) : (
                                        <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                                            <Button
                                                type="submit"
                                                className="alternate white"
                                                disabled={hasInputNoChange || !values?.question || !values?.response}
                                                startIcon={<CheckRoundedIcon />}
                                                disableRipple
                                                onClick={() => {
                                                    setFieldValue('isDrafted', false);

                                                    if (!values.question || !values.response) {
                                                        return;
                                                    }

                                                    handleEditResponse(values, false);
                                                }}
                                            >
                                                Save
                                            </Button>
                                        </PermisssionValidationWrapper>
                                    )}
                                </Stack>
                            </Stack>

                            {/* <Grid container rowSpacing={1.5}>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }}>
                                        <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel>
                                        <FormFields
                                            type="outlined-input"
                                            name="question"
                                            label="Question"
                                            value={values.question}
                                            id="outlined-adornment-title"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                let flag = false;
                                                if (selectedItem.question !== e.target.value) flag = true;
                                                dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                if (!e.target.value && !values.response)
                                                    dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                handleChange(e);
                                            }}
                                            inputprops={{}}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }} className="contact-textarea-formcontrol">
                                        <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel>
                                        <FormFields
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.response}
                                            name="response"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                let flag = false;
                                                if (selectedItem.response !== e.target.value) flag = true;
                                                dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                if (!values.question && !e.target?.value)
                                                    dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                handleChange(e);
                                            }}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box className="modal-footer-2">
                                        <Button
                                            type="submit"
                                            className="alternate-reversed"
                                            disabled={hasInputNoChange}
                                            onClick={() => {
                                                setFieldValue('isDrafted', true);
                                                handleDraftButtonClick(values);
                                            }}
                                        >
                                            Save as draft
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="alternate"
                                            disabled={hasInputNoChange}
                                            onClick={() => {
                                                setFieldValue('isDrafted', false);
                                                if (!values.question || !values.response) {
                                                    return;
                                                }
                                                handleEditResponse(values, false);
                                            }}
                                        >
                                            {selectedItem.drafted ? 'Add' : 'Update'}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid> */}
                        </Form>
                    )}
                </Formik>
            </Box>

            {isConfirmationModalOpen && (
                <EditConfirmationModal parentModalClose={handleCloseConfirmation} handleFormStateChange={handleFormStateChange} />
            )}
            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                className="question-delete-popover"
                sx={{
                    width: '200px'
                }}
            >
                <Box className="popover-wrap">
                    <List>
                        <MenuItem onClick={handleDelete} disableRipple>
                            <ListItemIcon>{<TrashIcon />}</ListItemIcon>
                            <ListItemText>Delete question</ListItemText>
                        </MenuItem>
                    </List>
                </Box>
            </Popover>
        </>
    );
};

export default EditTemplate;
